<template>
  <div class="left_nav">
    <el-menu
      :default-active="defaultActiveMenuIndex"
      :collapse="isCollapse"
      class="el-menu-vertical-demo">
      <!--<el-menu-item index="1" @click="toNewRouter('custom-payment-over-view')" v-if="permissionCodes.indexOf('015001000') !== -1" >-->
      <!--<i class="el-icon-damai-shujulaiyuan" style="font-size: 16px;"></i>-->
      <!--<span slot="title">概览</span>-->
      <!--</el-menu-item>-->
      <el-menu-item index="1" @click="toNewRouter('data-park-basic')" v-if="permissionCodes.indexOf('029001000') !== -1">
        <i class="el-icon-damai-basic"></i>
        <span slot="title">园区基础信息</span>
      </el-menu-item>
      <el-menu-item index="6" @click="toNewRouter('production-tax-statistics')" v-if="permissionCodes.indexOf('029005000') !== -1">
        <i class="el-icon-damai-jiaofeijilu1"></i>
        <span slot="title">生产税收统计</span>
      </el-menu-item>
      <el-menu-item index="2" @click="toNewRouter('data-park-honor')" v-if="permissionCodes.indexOf('029002000') !== -1">
        <i class="el-icon-damai-rongyu"></i>
        <span slot="title">园区荣誉&资质</span>
      </el-menu-item>
      <el-menu-item index="3" @click="toNewRouter('enterprise-cultivation')" v-if="permissionCodes.indexOf('029003000') !== -1">
        <i class="el-icon-damai-xiansuopeiyu" style="font-size: 20px;"></i>
        <span slot="title">企业培育</span>
      </el-menu-item>
      <el-menu-item index="4" @click="toNewRouter('upscale-elements')" v-if="permissionCodes.indexOf('029004000') !== -1">
        <i class="el-icon-damai-yaosutiqu"></i>
        <span slot="title">高端要素</span>
      </el-menu-item>
      <el-menu-item index="5" @click="toNewRouter('data-service-log')" v-if="permissionCodes.indexOf('029006000') !== -1">
        <i class="el-icon-damai-ic_caozuorizhi"></i>
        <span slot="title">操作日志</span>
      </el-menu-item>

      <!-- <div style="line-height: 50px;display: flex;justify-content: flex-start;align-items: center;padding-left: 25px;">
        <i class="el-icon-s-fold" style="font-size: 24px;color: #00a0e6;cursor: pointer;" @click="isCollapse = true" v-if="!isCollapse"></i>
        <i class="el-icon-s-unfold" style="font-size: 24px;color: #00a0e6;cursor: pointer;" @click="isCollapse = false" v-if="isCollapse"></i>
      </div> -->

    </el-menu>
  </div>
</template>

<script>
import navMixin from "../../utils/nav";
import { bus } from "../../utils/bus";

const indexOfRouterNameEntities = Object.entries({
  1: ["data-park-basic"],
  6: [
    "production-tax-statistics",
    "production-tax-statistics-add",
    "production-tax-statistics-modify"
  ],
  2: ["data-park-honor", "data-park-honor-add", "data-park-honor-modify"],
  3: [
    "enterprise-cultivation",
    "enterprise-cultivation-add",
    "enterprise-cultivation-modify"
  ],
  4: ["upscale-elements", "upscale-elements-add", "upscale-elements-modify"],
  5: ["data-service-log"]
});

export default {
  name: "data-service-nav",
  mixins: [navMixin],
  computed: {
    defaultActiveMenuIndex() {
      const { name: routeName } = this.$route;
      const entity = indexOfRouterNameEntities.find(([, routeNames]) => {
        if (routeNames instanceof Array) {
          return routeNames.indexOf(routeName) >= 0;
        } else {
          return routeNames === routeName;
        }
      });
      return entity && entity[0];
    }
  },
  data() {
    return {
      isCollapse: false,
      permissionCodes: "",
      indexOfRouterNameEntities
    };
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes;
  },
  mounted() {
    bus.vue.$on("changeIsCollapse", data => {
      this.isCollapse = data;
    });
  },
  methods: {
    toNewRouter(name) {
      this.$router.push({
        name: name
      });
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../components/CommonStyle/commonNavStyle";
</style>



// WEBPACK FOOTER //
// src/view/DataServicePark/DataServiceNav.vue